export const StockList = [
  { _id: true, label: "Rupture de stock", labelKey: "filters.outOfStock" },
  { _id: false, label: "En stock", labelKey: "filters.inStock" },
];

export const VisibilityList = [
  { _id: true, label: "Visible", labelKey: "filters.visible" },
  { _id: false, label: "Caché", labelKey: "filters.hidden" },
];